import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import { CheckIcon } from "@phosphor-icons/react/dist/csr/Check";
import { Item, ItemActions, ItemContent } from "@volca/ui/components/ui/item";
import { Separator } from "@volca/ui/components/ui/separator";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

interface OnboardingActionButtonProps {
  text: string;
  isCompleted: boolean | undefined;
  onClick: () => void;
}

export const OnboardingActionButton = ({
  text,
  isCompleted,
  onClick,
}: OnboardingActionButtonProps) => {
  const completed = Boolean(isCompleted);

  return (
    <>
      <Stack align="start" gap={4} className="relative w-full">
        <Item
          render={<button type="button" disabled={completed} />}
          size="sm"
          onClick={onClick}
          className={cn("rounded-none p-3 text-left", {
            "cursor-default opacity-50": completed,
          })}
        >
          <ItemContent>
            <Text className={cn({ "line-through": completed })}>{text}</Text>
          </ItemContent>
          {!completed && (
            <ItemActions>
              <CaretRightIcon className="h-4 w-4 text-subtle" />
            </ItemActions>
          )}
        </Item>
        {completed && (
          <div className="absolute top-1/2 right-3 -translate-y-1/2">
            <CheckIcon className={"h-4 w-4 text-success"} />
          </div>
        )}
      </Stack>
      <Separator />
    </>
  );
};
